


































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { filter, includes, isArray, isEmpty, some } from 'lodash';
import {
  SearchCondition,
  SearchRule,
  DisabledDate,
} from '@/models/flight-search';

@Component({
  components: {},
})
export default class DepartureArrival extends Vue {
  private dateRange = '';
  private dateChangebirthday(event) {
    this.$emit('change', event)
    alert(this.dateRange);
  }
  // @Prop()
  // private value: SearchCondition = {
  //   triptype: 'R',
  //   departdate: '',
  //   returndate: '',
  // };
  // @Prop()
  // private name: string;
  // @Prop()
  // private searchRule: SearchRule;

  // private dateRange: string[] = ['', ''];
  // private date: string = '';
  // private pickerOptions = {
  //   disabledDate: (givenDate: Date) => {
  //     return this.thisDateDisabled(givenDate);
  //   },
  // };

  // private thisDateDisabled(givenDate: Date) {
  //   const result = some(
  //     this.searchRule.disabledDate,
  //     (disabledDate: DisabledDate) => {
  //       const disabledStartDateObj = new Date(disabledDate.startDate);
  //       if (disabledDate.operator === 'le') {
  //         return disabledStartDateObj > givenDate;
  //       } else if (disabledDate.operator === 'ge') {
  //         return disabledStartDateObj < givenDate;
  //       } else if (disabledDate.operator === 'bet') {
  //         const disabledEndDateObj = new Date(disabledDate.endDate);
  //         return (
  //           disabledStartDateObj < givenDate && disabledEndDateObj > givenDate
  //         );
  //       } else {
  //         return false;
  //       }
  //     },
  //   );
  //   return result;
  // }

  // @Emit('input')
  // private changeSingleDate(value): SearchCondition {
  //   return {
  //     ...this.value,
  //     departdate: value,
  //   };
  // }

  // @Emit('input')
  // private changeRange(value): SearchCondition {
  //   return {
  //     ...this.value,
  //     departdate: value[0],
  //     returndate: value[1],
  //   };
  // }

  // @Watch('value')
  // private onSearchCondition(val: SearchCondition) {
  //   this.date = val.departdate;
  //   const returnDate = val.returndate || val.departdate;
  //   this.dateRange = [val.departdate, returnDate];
  // }
}
